import { render, staticRenderFns } from "./CRUDEventProcessCreate.vue?vue&type=template&id=39db85b3"
import script from "./CRUDEventProcessCreate.vue?vue&type=script&lang=js"
export * from "./CRUDEventProcessCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports